import React, { useEffect, useRef, useState } from "react";

/* 🎞 Frame counts */
const DESKTOP_FRAMES = 192;
const MOBILE_FRAMES = 192;

/* 🎥 Smoothness */
const DESKTOP_SMOOTHNESS = 0.06;
const MOBILE_SMOOTHNESS = 0.1;

/* 📝 SERVICES CONTENT */
const SCENES = [
  "",
  "Complete Auto Body, Mechanical & Interior Solutions",
  "For Jeep, Cars, Tempo & Pick-Up Vehicles",
  "Car & Vehicle Body Repair",
  "Painting & Color Matching",
  "Re-Shaping & Frame Alignment",
  "Car Body Welding",
  "Mechanical Services",
  "Denting & Damage Correction",
  "Cushion & Interior Work",
  "Alteration & Modification",
  "Floor Matting & Interior Protection",
  "Car Polishing & Paint Protection",
  "Expert Care for Every Vehicle",
  "",
  "",
  "",
  "",
];

export default function Services({ onFinish }) {
  const imgRef = useRef(null);
  const rafRef = useRef(null);
  const finishedRef = useRef(false);

  const currentFrame = useRef(1);
  const targetFrame = useRef(1);

  const [loaded, setLoaded] = useState(false);
  const [frameIndex, setFrameIndex] = useState(1);

  /* 📱 Device detect */
  const isMobile = window.innerWidth < 768;

  const FRAME_COUNT = isMobile ? MOBILE_FRAMES : DESKTOP_FRAMES;
  const SMOOTHNESS = isMobile ? MOBILE_SMOOTHNESS : DESKTOP_SMOOTHNESS;
  const folder = isMobile
    ? "images/frames/mobile"
    : "images/frames/desktop";

  /* 🧠 Equal frame distribution */
  const FRAMES_PER_SCENE = Math.floor(FRAME_COUNT / SCENES.length);
  const currentScene =
    SCENES[Math.min(
      Math.floor(frameIndex / FRAMES_PER_SCENE),
      SCENES.length - 1
    )];



    useEffect(() => {
  const images = [];
  let loadedCount = 0;

  const handleLoad = () => {
    loadedCount++;
    if (loadedCount === FRAME_COUNT) {
      setLoaded(true);
    }
  };

  for (let i = 1; i <= FRAME_COUNT; i++) {
    const img = new Image();
    img.src = `/${folder}/frame_${String(i).padStart(4, "0")}.webp`;
    img.onload = handleLoad; // no function in loop referencing loop variables
    images.push(img);
  }
}, [FRAME_COUNT, folder]);


  /* 🎬 Scroll animation */
  useEffect(() => {
    if (!loaded) return;

    const onScroll = () => {
      const scrollTop = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const progress = Math.min(scrollTop / maxScroll, 1);
      targetFrame.current = Math.floor(progress * (FRAME_COUNT - 1)) + 1;
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    const animate = () => {
      currentFrame.current += (targetFrame.current - currentFrame.current) * SMOOTHNESS;
      const frame = Math.round(currentFrame.current);

      if (imgRef.current) {
        imgRef.current.src = `/${folder}/frame_${String(frame).padStart(4, "0")}.webp`;
      }

      setFrameIndex(frame);

      // ✅ Trigger after last frame
      if (frame >= FRAME_COUNT - 1 && !finishedRef.current) {
        finishedRef.current = true;

        setTimeout(() => {
          const aboutSection = document.getElementById("about");
          if (aboutSection) {
            aboutSection.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }

          onFinish && onFinish();
        }, 500);
      }

      rafRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(rafRef.current);
    };
  }, [loaded, FRAME_COUNT, SMOOTHNESS, folder, onFinish]);

  return (
    <section id="services">
      <div style={{ height: isMobile ? "400vh" : "500vh", background: "#000" }}>
        {!loaded && <LoadingScreen />}

        <img
          ref={imgRef}
          src={`/${folder}/frame_0001.webp`}
          alt="Auto intro"
          style={imgStyle}
        />

        {loaded && currentScene && (
          <div style={textWrapper}>
            <h1 style={textStyle}>{currentScene}</h1>
          </div>
        )}
      </div>
    </section>
  );
}

/* 🖼 Image Style */
const imgStyle = {
  position: "fixed",
  inset: 0,
  width: "100vw",
  height: "100vh",
  objectFit: "cover",
  background: "#000",
};

/* 📝 Text Wrapper */
const textWrapper = {
  position: "fixed",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
  padding: "0 8vw",
};

/* 📝 Premium Silver Text */
const textStyle = {
  fontSize: "clamp(2.5rem, 6vw, 5.5rem)",
  fontWeight: 700,
  letterSpacing: "0.12em",
  textAlign: "center",
  textTransform: "uppercase",
  lineHeight: 1.3,
  color: "#CFCFCF",
  textShadow: `
    0 0 10px rgba(255,255,255,0.25),
    0 15px 40px rgba(0,0,0,0.9)
  `,
};

/* ⏳ Loading */
function LoadingScreen() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#aaa",
        fontSize: "1.4rem",
        letterSpacing: "4px",
        zIndex: 10,
      }}
    >
      LOADING EXPERIENCE…
    </div>
  );
}
